module.exports = __webpack_public_path__ + "img/ZA.de99d9d6.jpg";